<form [formGroup]="form" (submit)="_onSubmit($event)">
  <dynamicField *ngFor="let field of fields | removeFields:dynamicfields" [field]="field" [group]="form"
    [appearance]="appearance"></dynamicField>
  <div class="section btn-group" [ngClass]="{'hide': !cancelButton.enabled && !submitButton.enabled}">
<!--    <a [ngClass]="{'hide': !cancelButton.enabled}" src='' (click)="_onReset()"-->
<!--      id="cidaasCancelBtn"><label>{{cancelButton.text}}</label></a>-->
    <button [ngClass]="{'hide': !submitButton.enabled}" class="position_relative button-right" type="submit"
      mat-flat-button [color]="submitButton.matColor" id="cidaasSubmitBtn">{{submitButton.text}}</button>
  </div>
</form>
